"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cancelReasonOptions = void 0;
exports.cancelReasonOptions = [
    'too-expensive',
    'no-suitable-apartments',
    'bug',
    'other'
];
